module.exports = __webpack_public_path__ + "img/21-min.bada5ab1.jpg";